export default "__VITE_ASSET__CCwTNSm1__"